const endpoint = '/api/properties/groups';

export default ['api', function(api) {
  return {
    save: group => {
      let url = group.id ? `${ endpoint }/${ group.id }` : endpoint;

      return api.upload(url, group).then(response => response.data);
    },
    delete: id => api.delete(`${ endpoint }/${ id }`),
    findAll: (page = undefined, perpage = undefined, deleted = undefined) => {
      return api.get(endpoint+(page ? '?page='+(page)+ (page > -1 ? '&perpage='+(perpage || '20') : '') : '')+(deleted ? '&deleted=true' : '')).
        then(response => response.data);
    },
    findById: id => {
      return api.get(`${ endpoint }/${ id }`)
        .then(response => response.data);
    },
    search: (type, text, page = null) => {
      return api.get(`${endpoint}?type=${type}&text=${text}`+(page ? '&page='+page : '')).then(response => response.data);
    }
  };
}];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/property/services/property.group.service.js